import Accordion from "@storeblocks/accordion";
import styled from "styled-components";

export const PrepopulateInfoBox = styled.div`
  align-items: flex-start;

  /* background-color: ${({ theme }) =>
    theme.surface.backgroundColor ?? "#f5f9f0"};
     */
  background-color: var(--p-color-surface-1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  margin-bottom: 16px;
  padding: 16px;
`;

export const PrepopulateInfoBoxDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  margin-top: 12px;
`;

export const PrepopulateInfoBoxRow = styled.div`
  margin-bottom: 4px;
  margin-top: 4px;
`;

export const PrepopulateAccordion = styled(Accordion)`
  margin-bottom: 16px;
`;
